import React from 'react'
import OnVisible from 'react-on-visible'
import { Section, Image, TaglineTitleContent, PrimarySecondaryButtons } from 'newComponents'
import classNames from 'classnames'
import { ReactComponent as Sphere } from '../../images/home/sphere.svg'
import { ReactComponent as BackgroundStars } from '../../images/_background-stars/compare_background_stars.svg'
import { ReactComponent as SphereLayerMid } from '../../images/_background-stars/compare-right-stars.svg'

import './styles.scss'

const TextImageHeader = (props) => {
  const { data } = props
  const { primary } = data
  const {
    content,
    primary_cta_link: ctaLinkOne,
    primary_cta_text: ctaTextOne,
    secondary_cta_link: ctaLinkTwo,
    secondary_cta_text: ctaTextTwo,
    image,
    image_left: imageLeft,
    tagline,
    title,
    no_bg_graphics: noBg,
    full_width_centered_title: fullWidthCentered,
    background_color: bgColor
  } = primary

  // content checks
  const titleHtml = title?.html
  const contentHtml = content?.html
  const taglineHtml = tagline?.html
  const hasImage = image?.url
  const hasPrimaryCta = ctaLinkOne?.url && ctaTextOne?.text
  const hasSecondaryCta = ctaLinkTwo?.url && ctaTextTwo?.text
  const isWhiteBg = bgColor === 'white'

  let hasContent = true
  if (fullWidthCentered) {
    hasContent = contentHtml.length > 0
  } else {
    hasContent = contentHtml.length > 0 || titleHtml.length > 0 || taglineHtml.length > 0
  }

  return (
    <div
      className={classNames('text-image-header', {
        'left-align': imageLeft,
        'no-image': !hasImage,
        'no-bg': noBg,
        [`bg-${bgColor}`]: bgColor
      })}
    >
      <OnVisible className="text-image-header-header">
        {!isWhiteBg && <BackgroundStars className="text-image-header-background-stars" />}
        <Section noWrapper className="text-image-header-container">
          {fullWidthCentered && (
            <div className="text-image-header-top-title">
              {title && <div className="tagline-title-content-title" dangerouslySetInnerHTML={{ __html: titleHtml }} />}
              {tagline && (
                <div className="tagline-title-content-header">
                  <div className="tagline-title-content-tagline" dangerouslySetInnerHTML={{ __html: taglineHtml }} />
                </div>
              )}
            </div>
          )}
          <div className="new-container">
            {hasContent && (
              <div className="text-image-header-header-left">
                <TaglineTitleContent
                  fullWidthCentered={fullWidthCentered}
                  tagline={taglineHtml}
                  title={titleHtml}
                  content={contentHtml}
                />
                {(hasPrimaryCta || hasSecondaryCta) && (
                  <PrimarySecondaryButtons
                    primaryText={ctaTextOne.text}
                    primaryLink={ctaLinkOne.url}
                    secondaryText={ctaTextTwo.text}
                    secondaryLink={ctaLinkTwo.url}
                  />
                )}
              </div>
            )}
            {hasImage && (
              <Image
                className={classNames('text-image-header-image', {
                  'full-width-image': !hasContent,
                  'wider-image': fullWidthCentered
                })}
                image={image}
              />
            )}
            {!isWhiteBg && (
              <>
                <Sphere className="text-image-header-header-sphere" />
                <SphereLayerMid className="text-image-header-header-layer-mid" />
              </>
            )}
          </div>
        </Section>
      </OnVisible>
    </div>
  )
}

export default TextImageHeader
